module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsChristmas@2x.41e38da.jpg";